import * as types from "./types";

import { JSON_STRING, HttpClient, MHTTPCL } from "../../../../services/http/http-client";
import { getNavTabModule } from "../../../../dt-plugins/sidewindow/nav-tab";
//import { EOL_REACHED } from "../../../../dt-plugins/advanced-search/load.model";
import { setMainNavInactive } from "../../../../store/app/mutations";
import { EOL_REACHED, LoadedEnd } from '../../../../dt-plugins/advanced-search/load.model';
import { SupplierOrdersService } from "../../services/supplier.order.service";
import router from '../../../../router';
const NavTabModule = getNavTabModule(types.DistributionSupplierOrderDetails, 'distributionSupplierOrderDetails');

export const distributionSupplierOrderActions = {
    async [types.DistributionSupplierOrderList.FETCH.ALL]({ commit,getters,dispatch }, payload) {
        // const orderData = await OrderService.getOrderList();
        // console.log("Log: orderData", orderData);
    
        // commit(types.DistributionSupplierOrderList.SET.ALL, orderData.data.orders);
        const { start, row_count, searchMode, basicFilter, searchFilter } = payload;
    
    
        let res;
        console.log("PAYLOAD:::",payload);
        
        if (searchMode == 'none') {
          if (start == 0) {
                        
            // console.log(":::RES:::",typeRes)
    
            res = await HttpClient.mergeRequests([
                SupplierOrdersService.distSuppliersTabSupplierOrdersList()
            ]);
    
            console.log("RES:::",res)
    
            commit(types.DistributionSupplierOrderList.SET.ALL,  {...res } );  // <-- Directly Set the Data. Depends on your particular Logic
          } else {                // <-- Pagination Logic
             res = await SupplierOrdersService.supplierOrders(start)    // <-- Pagination Logic
             console.log("PAYLOAD:::::::::::::",res);
            // console.log("res",res)
          
            commit(types.DistributionSupplierOrderList.SET.ALL, { // <-- Set the Data. Here the actual List is nested. Depends on your particular case
              ...getters.distributionSupplierOrderList,
              supplier_orders: [
                ...getters.distributionSupplierOrderList.supplier_orders,
                ...res.data.supplier_orders, // <-- append new Fetched List
              ]
            });
    
            // Setting EOL
            // if (!(res?.data?.length <= 0)) {
            //   return EOL_REACHED;
            // }
          }
    
        }else if (searchMode == 'basic') {
           const {   searchString , licence_statuses,royalty_period ,invoice_project,statement_type } = basicFilter;
      
           res = await SupplierOrdersService.filterSupplierOrders({...basicFilter});
           //commit(types.DistributionSupplierOrderList.SET.ALL,res.data.orders);
           console.log("Search res",getters.distributionSupplierOrderList,res.data.supplier_orders)
           commit(types.DistributionSupplierOrderList.SET.ALL, { 
            ...getters.distributionSupplierOrderList,
            supplier_orders: [
             // ...getters.distributionSupplierOrderList.orders,
              ...res.data.supplier_orders, 
            ]
          });
    
           console.log("Search res",res.data.supplier_orders)
          if (start == 0) {
            // <-- Set the Data. Here the actual List is nested. Depends on your particular case
          
          } 
          // else {                // <-- Pagination Logic
          //   commit(types.TrackList.SET.ALL, {               // <-- Pagination Logic
          //     ...getters.trackList,
          //     tracks: [
          //       ...getters.trackList.tracks,
          //       ...res.data // <-- append new Fetched List
          //     ]
          //   });
          // }
      
      
          // Setting EOL
          // if (!(res?.data?.length > 0)) {
          //   return EOL_REACHED;
          // }
        } 
    
          //const statementOverviewData = await HttpClient.mergeRequests(promises);
        
        //console.log("StatementOverviewData",statementOverviewData);
    
         //commit(types.BelieveStatementList.SET.ALL,  statementOverviewData );
    
    
    
      },
      async [types.DistributionSupplierOrderList.DELETE.SINGLE]({ commit,getters,dispatch }, payload){
        const { supplier_order_id } = payload;
        console.log(getters.distributionSupplierOrderList,":::::::")
        // const list={
        //   ... getters.distributionSupplierOrderList,
        //   supplier_orders:supplier_orders.filter(e=>e.supplier_order_id!=supplier_order_id)
        // }
       commit(types.DistributionSupplierOrderList.SET.ALL,{
          ... getters.distributionSupplierOrderList,
          supplier_orders:getters.distributionSupplierOrderList.supplier_orders.filter(e=>e.supplier_order_id!=supplier_order_id)
       })


       const resData = SupplierOrdersService.removeSupplierOrder(supplier_order_id);
       
        // commit(types.DistributionSupplierOrderList.DELETE.SINGLE,supplier_order_id);
        


      },
      async [types.DistributionSupplierOrderList.UPDATE.SINGLE]({ commit,getters,dispatch }, payload){
        const { item ,name ,value } = payload;

        const { supplier_order_id } = item;

        console.log(getters.distributionSupplierOrderList,":::::::")
        // const list={
        //   ... getters.distributionSupplierOrderList,
        //   supplier_orders:supplier_orders.filter(e=>e.supplier_order_id!=supplier_order_id)
        // }
       commit(types.DistributionSupplierOrderList.SET.ALL,{
          ... getters.distributionSupplierOrderList,
          supplier_orders:getters.distributionSupplierOrderList.supplier_orders.map(e=> {
              if(e.supplier_order_id == supplier_order_id){
                return {
                  ...e,
                  [name]:value
                }
              }else{
                return { ...e }
              }
            }
          )
       })


       const resData = MHTTPCL.modify(undefined,supplier_order_id,name,value,'l_supplier_orders')
       
        // commit(types.DistributionSupplierOrderList.DELETE.SINGLE,supplier_order_id);
        


      },

      async [types.DistributionSupplierOrderDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload = {}) {
        const NavTabHelper = NavTabModule.Helper(dispatch, getters)
        
        console.log(":::::::::::::::::::::::::::::::::::SO",payload)

        let { flag, order, reload } = payload;
    
        flag = typeof flag === 'boolean' ? flag : true;
    
        setMainNavInactive(commit, flag);
    
        const primaryKey = 'supplier_order_id';
        const itemName = 'order';
        const item = payload[itemName];
    
        if (!item) {
          return;
        }
    
        const primaryKeyValue = item[primaryKey];
        const detailsGetterKey = 'distributionSupplierOrderDetails';
        const DetailsAction = types.DistributionSupplierOrderDetails;
    
    
        // Check Reload and prexisting Item Logic
    
        if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
          return;
        }
    
        NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
          return {
            [itemName]: item,
            loading: true,
          }
        })
    
        // HTTP Req
    
        const detailsResponse = await HttpClient.mergeRequests([
          SupplierOrdersService.supplierOrderDetails(order.supplier_order_id),
          SupplierOrdersService.supplierOrderDetailsTabOverview(order.supplier_order_id),
          SupplierOrdersService.supplierOrderDetailsTabBackorders(order.supplier_order_id),
          SupplierOrdersService.getDeliveries(order.supplier_order_id)
        ]);
    
        console.log("DETaIlS OF RESponSE", detailsResponse);
    
    
        NavTabHelper.setSingleNavTabDetails(primaryKeyValue, (detailsDict, order) => {
          return {
           // ...order,
            ...detailsResponse,
            loading: false,
          }
        })
      },

      ...NavTabModule.implementActions(
        'supplier_order_id',
        'supplier_order/supplier_order_id/tab',
        'supplier_order',
        () => router,
        'distribution',
        (value, key) => {
          console.log("value, key",{value, key})
          return {
            title: (value && value.order && value.order.supply_order_type_name) ? value.order.supply_order_type_name : key,
            full_title: (value && value.order && value.order.supply_order_type_name) ? value.order.supply_order_type_name : key
          }
        }
      ),

      async [types.DistributionSupplierOrderDetails.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
        //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)
    
    
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);
        const { name, value, item } = payload

        console.log(item,"::::::")

        const { supplier_order } = item;
        const { supplier_order_id } = supplier_order;
    
    
        console.log("types.ReleaseDetails.UPDATE.SINGLE", name, value, item)
        NavTabHelper.updateSingleNavTabDetails(supplier_order_id, (selectedSupplierOrderDetails) => {
          return {
            supplier_order: {
              ...selectedSupplierOrderDetails.supplier_order,
              [name]: value,
            }
          }
        });
        
        const modifiedRelease = await MHTTPCL.modifyJSON('supplier_order_id', supplier_order_id, name, value, 'l_supplier_orders')
    
    
    
    
    
    
      },

      async [types.SET_DISTRIBUTION_SUPPLIER_ORDER_FILES]({ dispatch, getters }, { files, externalId, externalTable }) {
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);
        const supplier_order_id = externalId;
        NavTabHelper.setSingleNavTabDetails(supplier_order_id, (_, selectedSupplierOrderDetails) => {
          return {
            ...selectedSupplierOrderDetails,
            related_documents: files,
          }
        });
      },


      async [types.DistributionSupplierOrderSOrderLines.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
        //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)
    
    
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);
        const { name, value, kVal ,item , objKey} = payload

        console.log(item,"::::::")

        const { supplier_order } = item;
        const { supplier_order_id } = supplier_order;
    
        NavTabHelper.updateSingleNavTabDetails(supplier_order_id, (selectedSupplierOrderDetails) => {
          return {
            [objKey]: selectedSupplierOrderDetails[objKey].map(e=>{
              if (e.supplier_orderline_id == kVal) {
                return {
                  ...e,
                  [name]: value,
                };
              } else {
                return e;
              }
            }),
            
            
          }
        });
        
        const modifiedRelease = await MHTTPCL.modifyJSON('supplier_orderline_id', kVal, name, value, 'l_supplier_orderlines')
      },


      async [types.DistributionSupplierOrderSOrderLines.UPDATE.MULTIPLE]({ commit, getters, dispatch }, payload) {
        //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)
    
    
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);
       
        console.log(payload,"::::::")
        const { supplier_order_id } = payload;

        const newData = await SupplierOrdersService.accountDeliveryData(payload);

        console.log("NEWDATA",newData);

    
        NavTabHelper.updateSingleNavTabDetails(supplier_order_id, (selectedSupplierOrderDetails) => {
          return {
            s_orderlines:newData.data.s_orderlines
            
            
          }
        });
        
        
      },

      async [types.DistributionSupplierOrderSOrderLines.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
        //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)
    
    
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);
        const { supplier_order } = payload;
        const { supplier_order_id } = supplier_order;

        const resNewSupplierOrderLine =await SupplierOrdersService.addSupplierOrderline(supplier_order_id);
        
        console.log(resNewSupplierOrderLine);

        NavTabHelper.updateSingleNavTabDetails(supplier_order_id, (selectedSupplierOrderDetails) => {
          return {
            s_orderlines:[...resNewSupplierOrderLine.data.s_orderlines]            
            
          }
        });

      },

      async [types.DistributionSupplierOrderSOrderLines.INSERT.MULTIPLE]({ commit, getters, dispatch }, payload) {
        //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)
    
    
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);
        // const { supplier_order } = payload;
        const  { supplier_order_id }  = payload;

        const resOrderLineList =await SupplierOrdersService.getLabelAccounts(supplier_order_id);
        
        console.log(resOrderLineList);

        NavTabHelper.updateSingleNavTabDetails(supplier_order_id, (selectedSupplierOrderDetails) => {
          return {
            s_orderlines:[...resOrderLineList.data.s_orderlines]            
            
          }
        });

      },

      async [types.DistributionSupplierOrderSOrderLines.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
        //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)
    
    
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);
        const { supplierOrderItem , item,objKey } = payload

        console.log(supplierOrderItem,"::::::")

        const { supplier_orderline_id } =supplierOrderItem

        const { supplier_order } = item;
        const { supplier_order_id } = supplier_order;

       // const resNewSupplierOrderLine =await SupplierOrdersService.addSupplierOrderline(supplier_order_id);
        
        //console.log(resNewSupplierOrderLine);

        NavTabHelper.updateSingleNavTabDetails(supplier_order_id, (selectedSupplierOrderDetails) => {
          return {
            [objKey]:selectedSupplierOrderDetails[objKey].filter(e=>e.supplier_orderline_id!=supplier_orderline_id)           
            
          }
        });

        await SupplierOrdersService.removeSupplierOrderline(supplier_orderline_id); 

      },

      async [types.DistributionSupplierOrderOrderLines.INSERT.MULTIPLE]({ commit, getters, dispatch }, payload) {
        //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)
    
    
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);
        const { supplier_order_id } = payload

        const res = await SupplierOrdersService.loadSupplierOrderlines(supplier_order_id);

        console.log(":::::::::::::::RES",res,"::::::RES")

        // const { supplier_order } = item;
        // const { supplier_order_id } = supplier_order;
    
        NavTabHelper.updateSingleNavTabDetails(supplier_order_id, (selectedSupplierOrderDetails) => {
          return {
            orderlines:[ ...res.data.orderlines ]
            
            
          }
        });
        
        
      }, 

      async [types.DistributionSupplierOrderOrderLines.DELETE.MULTIPLE]({ commit, getters, dispatch }, payload) {
        //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)
    
    
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);
        const { supplier_order_id } = payload

        const res = await SupplierOrdersService.removeAllLinesSo(supplier_order_id);

        console.log(":::::::::::::::RES",res,"::::::RES")

        // const { supplier_order } = item;
        // const { supplier_order_id } = supplier_order;
    
        NavTabHelper.updateSingleNavTabDetails(supplier_order_id, (selectedSupplierOrderDetails) => {
          return {
            orderlines:[  ]
            
            
          }
        });
        
        
      }, 

      // async [types.DistributionSupplierOrderOrderLines.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
      //   //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)
    
    
      //   const NavTabHelper = NavTabModule.Helper(dispatch, getters);
      //   const { name, value, kVal ,item } = payload

      //   console.log(item,"::::::")

      //   const { supplier_order } = item;
      //   const { supplier_order_id } = supplier_order;
    
      //   NavTabHelper.updateSingleNavTabDetails(supplier_order_id, (selectedSupplierOrderDetails) => {
      //     return {
      //       orderlines: selectedSupplierOrderDetails.orderlines.map(e=>{
      //         if (e.supplier_orderline_id == kVal) {
      //           return {
      //             ...e,
      //             [name]: value,
      //           };
      //         } else {
      //           return e;
      //         }
      //       }),
            
            
      //     }
      //   });
        
      //   const modifiedRelease = await MHTTPCL.modifyJSON('supplier_orderline_id', kVal, name, value, 'l_supplier_orderlines')
      // },

      // async [types.DistributionSupplierOrderOrderLines.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
      //   //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)
    
    
      //   const NavTabHelper = NavTabModule.Helper(dispatch, getters);
      //   const { supplierOrderItem , item } = payload

      //   console.log(supplierOrderItem,"::::::")

      //   const { supplier_orderline_id } =supplierOrderItem

      //   const { supplier_order } = item;
      //   const { supplier_order_id } = supplier_order;

      //  // const resNewSupplierOrderLine =await SupplierOrdersService.addSupplierOrderline(supplier_order_id);
        
      //   //console.log(resNewSupplierOrderLine);

      //   NavTabHelper.updateSingleNavTabDetails(supplier_order_id, (selectedSupplierOrderDetails) => {
      //     return {
      //       orderlines:selectedSupplierOrderDetails.orderlines.filter(e=>e.supplier_orderline_id!=supplier_orderline_id)           
            
      //     }
      //   });

      //   await SupplierOrdersService.removeSupplierOrderline(supplier_orderline_id); 

      // },


      async [types.DistributionSupplierOrderSOProduct.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
        //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)
    
    
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);

        const { name,value ,item_id , supplier_order_id , objKey} = payload;
    
    
        //console.log("types.ReleaseDetails.UPDATE.SINGLE", name, value, item)
        NavTabHelper.updateSingleNavTabDetails(supplier_order_id, (selectedSupplierOrderDetails) => {
          return {
            [objKey]: {
              ...selectedSupplierOrderDetails[objKey],
              [name]: value,
            }
          }
        });
        
        //const modifiedRelease = await MHTTPCL.modifyJSON('supplier_order_id', supplier_order_id, name, value, 'l_supplier_orders')
        if(name=='catalog_no'){
          const res = await SupplierOrdersService.addSupplierOrderProduct(supplier_order_id,item_id)
        }else{
          const res = await SupplierOrdersService.addSupplierOrderAccount(supplier_order_id,item_id)
        }
        
    
    
    
    
    
      },


      // async [types.DistributionSupplierOrderSO.INSERT.MULTIPLE]({ commit, getters, dispatch }, payload) {
      //   //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)
    
    
      //   const NavTabHelper = NavTabModule.Helper(dispatch, getters);
      //   // const { supplier_order } = payload;
      //   const  { supplier_order_id }  = payload;

      //   const resOrderLineList =await SupplierOrdersService.getLabelAccounts(supplier_order_id);
        
      //   console.log(resOrderLineList);

      //   NavTabHelper.updateSingleNavTabDetails(supplier_order_id, (selectedSupplierOrderDetails) => {
      //     return {
      //       so:{
      //         ...selectedSupplierOrderDetails.so,

      //       }            
            
      //     }
      //   });

      // },

      //backorder

      async [types.DistributionSupplierOrderBOrderLines.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
        //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)
    
    
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);
        const { supplier_order } = payload;
        const { supplier_order_id } = supplier_order;

        const resNewSupplierOrderLine =await SupplierOrdersService.addSupplierOrderlineFromBo(supplier_order_id);
        
        console.log(resNewSupplierOrderLine);

        NavTabHelper.updateSingleNavTabDetails(supplier_order_id, (selectedSupplierOrderDetails) => {
          return {
            orderlines:[...resNewSupplierOrderLine.data.orderlines]            
            
          }
        });

      },
};
